(function () {
  if (window.__sipitContactInit) return;
  window.__sipitContactInit = true;

  const roots = document.querySelectorAll('.sipit-contact');
  if (!roots.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  roots.forEach((root) => {
    root.querySelectorAll('.reveal').forEach((el, i) => {
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });

    const form = root.querySelector('.sipit-contact-form');
    if (!form) return;

    const fn = form.querySelector('[data-field="first-name"]');
    const ln = form.querySelector('[data-field="last-name"]');
    const nameHidden = form.querySelector('[name="contact[name]"]');
    const topic = form.querySelector('[data-field="topic"]');
    const order = form.querySelector('[data-field="order"]');
    const body = form.querySelector('[name="contact[body]"]');
    const tags = form.querySelector('[name="contact[tags]"]');

    const required = form.querySelectorAll('[data-required]');

    form.addEventListener('submit', (e) => {
      let ok = true;

      required.forEach((field) => {
        const empty = !field.value.trim();
        field.classList.toggle('is-error', empty);
        if (empty) ok = false;
      });

      if (!ok) {
        e.preventDefault();
        return;
      }

      if (nameHidden && fn && ln) {
        nameHidden.value = [fn.value.trim(), ln.value.trim()].filter(Boolean).join(' ');
      }

      if (body && (order?.value.trim() || topic?.value)) {
        const parts = [];
        if (topic?.value) parts.push('Topic: ' + topic.value);
        if (order?.value.trim()) parts.push('Order: ' + order.value.trim());
        parts.push('');
        parts.push(body.value.trim());
        body.value = parts.join('\n');
      }

      if (tags && topic?.value) {
        tags.value = topic.value;
      }
    });

    required.forEach((field) => {
      field.addEventListener('input', () => {
        if (field.value.trim()) field.classList.remove('is-error');
      });
    });
  });
})();
